module.exports = __webpack_public_path__ + "static/media/AG Grenade Only Transparent.3d330caf.svg";